import { useEffect } from 'react'
import { useFormState } from 'react-hook-form'
import type { z } from 'zod'
import { useCurrentRef } from '#src/hooks/useCurrentRef.ts'
import type { FormSchema, UseFormReturn } from '#src/hooks/useForm.ts'

export function useResetOnSubmit<TSchema extends FormSchema>(
  form: UseFormReturn<TSchema>,
  defaultValues: z.infer<TSchema>
): void {
  const { isSubmitSuccessful } = useFormState({
    control: form.control,
  })

  const reset = form.reset
  const defaultValuesRef = useCurrentRef(defaultValues) // We use a ref so that the dependency array below doesn't change when defaultValues changes.
  useEffect(() => {
    if (isSubmitSuccessful) {
      reset(defaultValuesRef.current) // We put this in useEffect instead of in the render function because react-hook-form recommends using reset inside useEffect: https://react-hook-form.com/docs/useform/reset
    }
  }, [isSubmitSuccessful, reset, defaultValuesRef])
}
